import "modules/knowledge/lang"

import { createFileRoute, Outlet } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/knowledge")({
  component: RouteComponent,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("knowledge.title"),
    })
  },
})

function RouteComponent() {
  return <Outlet />
}
